/* src/pages/admin/AdminMediaLibrary.js (Updated) */
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const MediaItem = ({ file, onSelect }) => {
    const isVideo = file.key.endsWith('.mp4') || file.key.endsWith('.mov');
    return (
        <div className="media-item" onClick={() => onSelect(file.url)}>
            {isVideo ? (
                <div className="media-thumbnail video">
                    <span className="material-icons">videocam</span>
                </div>
            ) : (
                <img src={file.url} alt={file.key} className="media-thumbnail" />
            )}
            <div className="media-key" title={file.key.split('/').pop()}>{file.key.split('/').pop()}</div>
        </div>
    );
};

const AdminMediaLibrary = ({ s3Prefix, onSelect, onCancel }) => {
    const [files, setFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(null);

    const fetchFiles = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const token = localStorage.getItem('app_token');
            const response = await axios.get(`/api/media/list?prefix=${s3Prefix}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setFiles(response.data);
        } catch (err) {
            setError('Could not load media files.');
        } finally {
            setIsLoading(false);
        }
    }, [s3Prefix]);

    useEffect(() => {
        fetchFiles();
    }, [fetchFiles]);

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploading(true);
        setError(null);
        const formData = new FormData();
        formData.append('file', file);
        formData.append('prefix', s3Prefix);

        try {
            const token = localStorage.getItem('app_token');
            const response = await axios.post('/api/media/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}`
                }
            });
            onSelect(response.data.url);
        } catch (err) {
            setError('Upload failed. Please try again.');
        } finally {
            setUploading(false);
        }
    };

    return (
        // FIX: Added 'media-library-overlay' class for z-index control
        <div className="admin-modal-overlay media-library-overlay">
            <div className="admin-modal-content media-library">
                <div className="media-library-header">
                    <h2>Select Media</h2>
                    <button onClick={onCancel} className="close-btn">&times;</button>
                </div>
                
                <div className="media-library-actions">
                     <label className="btn-primary">
                        {uploading ? 'Uploading...' : 'Upload New File'}
                        <input type="file" onChange={handleFileChange} disabled={uploading} style={{ display: 'none' }} />
                    </label>
                </div>

                {error && <p className="error-message">{error}</p>}
                
                <div className="media-grid">
                    {isLoading ? <p>Loading...</p> : files.map(file => (
                        <MediaItem key={file.key} file={file} onSelect={onSelect} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AdminMediaLibrary;
